import React from 'react';
import classNames from 'classnames';
import './EitherOrPanel.less';

export interface IEitherOrPanelProps extends React.HTMLProps<HTMLDivElement> {
  currentChoiceId: string | null | undefined;
  choiceId: string;
}

//TODO alex: use TabPanel inside
export function EitherOrPanel(props: React.PropsWithChildren<IEitherOrPanelProps>) {
  const { children, choiceId, currentChoiceId, className, ...other } = props;
  const isHidden = choiceId !== currentChoiceId;
  return (
    <div
      className={classNames('dpc-either-or-dialog__panel', className, {
        'dpc-either-or-dialog__panel--hidden': isHidden,
      })}
      role="tabpanel"
      hidden={isHidden}
      {...other}
    >
      {choiceId === currentChoiceId && children}
    </div>
  );
}
